import { Vue, Component, Prop, Inject } from 'vue-property-decorator';
import VueMultiSelect from 'vue-multiselect';

@Component({
    name: 'field-render',
    components: {
        'vue-multi-select': VueMultiSelect,
    },
})

export default class FieldRender extends Vue {

    @Inject('validator') public $validator: any;

    // ------------------------------------------------------------
    // Properties

    @Prop({default: null})
    private fieldObj: any;

    private bindProp: any = {};

    private eventBind: any = {};

    @Prop()
    private toolData: any;

    @Prop({default: false})
    private submitted?: boolean;

    private get imageURL() {
        const fieldObj = this.fieldObj;
        let modelValue = this.toolData[fieldObj.modelKey];
        if (fieldObj.isFileUpload && modelValue instanceof File) {
            modelValue = URL.createObjectURL(modelValue);
        }
        return modelValue;
    }


    // -------------------------------------------------------------
    // Hooks

    private created() {
        this.updateFieldProps();
    }

    private updated() {
        this.updateFieldProps();
    }

    // -------------------------------------------------------------------
    // Methods

    private updateFieldProps() {
        const fieldObj = this.fieldObj;
        if (fieldObj.propBind) {
            this.bindProp = fieldObj.propBind;
        }
        if (fieldObj.eventBind) {
            this.eventBind = fieldObj.eventBind;
        }
    }

}
